import { useRef } from "react";

const useConst = (fn) => {
  const ref = useRef();
  if (!ref.current) {
    ref.current = { value: fn() };
  }
  return ref.current.value;
};

export default useConst;
